import { v4 as uuid } from 'uuid';

import { IPatient, Gender, v2, constants, JobType } from '../../..';
import { admissionAdapter, jobAdapter, personAdapter } from '.';
import { getDefaults } from './helpers/getDefaults';
import { getGenderName } from './helpers/getGenderName';

export type ExtendedPatient = IPatient & {
    lastCompletedJob?: IPatient;
    nextUpcomingJob?: IPatient;
};

export const patientAdapter = (patient: ExtendedPatient): v2.Patient => {
    const {
        nhsNumber,
        pds,
        lastCompletedJob,
        nextUpcomingJob,
        staffPreferredGender,
        jobType,
        odsCode,
        practice,
        firstName,
        lastName,
        gender,
    } = patient;

    const defaults = getDefaults(patient);

    let genderPreferences: v2.GenderPreference[] | null = null;
    let person: v2.Person | null = null;

    if (staffPreferredGender?.length) {
        genderPreferences = staffPreferredGender.map((genderPreference) => {
            const genderId = getGenderName(genderPreference as Gender);

            return {
                ...defaults,
                id: uuid(),
                genderId,
                gender: {
                    ...defaults,
                    id: constants.NOT_CAPTURED,
                    name: genderId,
                },
                patientId: constants.NOT_CAPTURED,
            };
        });
    }

    if (firstName && lastName && gender) {
        person = personAdapter(patient);
    }

    const result: v2.Patient = {
        ...defaults,
        nhsNumber,
        person,
        genderPreferences,
        id: constants.NOT_CAPTURED,
        personId: constants.NOT_CAPTURED,
        pdsVersion: pds?.versionId,
        gpPracticeCode: odsCode,
        gpPracticeName: practice,
    };

    if (lastCompletedJob) {
        result.lastCompletedJob = jobAdapter(lastCompletedJob);
    }

    if (nextUpcomingJob) {
        result.nextUpcomingJob = jobAdapter(nextUpcomingJob);
    }

    if (jobType === JobType.UCR) {
        result.admissions = [admissionAdapter(patient)];
    }

    return result;
};
